module.exports = __webpack_public_path__ + "static/media/gusd.471ea5d9.svg";